import calculateMaxVerticalAngleOfView from 'helpers/calculations/calculateMaxVerticalAngleOfView'

export function multiplier({ angleOfView, conventional, aspectRatio }) {
  // angleOfView = 180 if @isStreetViewImage(@currentBackgroundImageUrl()) && @calculator.fovModeIsConventional()
  return 1 / Math.tan(angleOfView * 0.5 * (Math.PI / (conventional ? 180 : calculateMaxVerticalAngleOfView({ aspectRatio }))))
}

export function calculateBackgroundSize({ multiplier, width, aspectRatio }) {
  const backgroundWidth = (width + width * multiplier).toFixed(0)
  return {
    backgroundHeight: (backgroundWidth * aspectRatio).toFixed(0),
    backgroundWidth
  }
}

export function backgroundSize({ angleOfView, width, height, aspectRatio, conventional }) {
  const { backgroundWidth, backgroundHeight } = calculateBackgroundSize({
    multiplier: multiplier({ angleOfView, conventional, aspectRatio }),
    width, height, aspectRatio
  })
  return {
    backgroundSizeX: conventional ? backgroundWidth : backgroundHeight,
    backgroundSizeY: conventional ? backgroundHeight : backgroundWidth
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/backgroundSize.js